import {
  buildOrderLiteral,
  buildPagingLiteral,
  buildWhereLiteral,
  OrderBy,
} from '@/lib/graphql-query-builder';

/**
 * The Blocks OS gateway names query operations `get<Collection>`, and pluralizes by the literal
 * schema name + "s" (`NocType` -> `NocTypes`, confirmed via `blocks data schema list`). Aliased so
 * services and hooks read `result.NocTypes`, matching the read-only query the NOC apply form
 * already uses (`src/modules/service-desk/hr-noc/services/noc.service.ts`).
 *
 * A to Z by name by default, like the old NOC type list's `SortBy(x => x.Name)`.
 */
export const DEFAULT_NOC_TYPES_ORDER: OrderBy[] = [{ field: 'Name', direction: 'ASC' }];

export const buildGetNocTypesQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number,
  order: OrderBy[] = DEFAULT_NOC_TYPES_ORDER
) => `
  query {
    NocTypes: getNocTypes(
      where: ${buildWhereLiteral(where)}
      order: ${buildOrderLiteral(order)}
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      hasNextPage
      hasPreviousPage
      totalCount
      totalPages
      pageSize
      pageNo
      items {
        ItemId
        CreatedDate
        LastUpdatedDate
        Name
        DocumentBody
      }
    }
  }
`;
